import { Note, TUserId } from '/src/lib/models';

/**
 * Create Note
 */
export type TCreateNoteRequest = {
  content: string;
  created?: Date;
  updated?: Date;
  user: {
    id?: TUserId;
    displayName?: string;
  };
  roles: string[];
  // roles: ['admin', 'user', '']; // include an empty string to accommodate legacy bug
};

export type TCreateNoteResponse = Note;

/**
 * Update Note
 */
export type TUpdateNoteRequest = {
  content?: string;
  updated?: Date;
  user?: {
    id?: TUserId;
    displayName?: string;
  };
  roles?: string[];
  // roles: [UserRole.Admin, UserRole.User, '']; // include an empty string to accommodate legacy bug
};

export type TUpdateNoteResponse = Note;
